import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/usr-role`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/usr-role`,
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli1030001q: `${BASE.path}/ptli1030001q`, // Custom Office User Auth Management List !== 세관 사용자 권한 관리 목록 ==!
    ptli1030002s: `${BASE.path}/ptli1030002s`, // Custom Office User Auth Management List !== 세관 사용자 권한 관리 목록 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getCstmUsrList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/cstm-usr?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),
    getCstmUsrInfo: (data: any) => api.get(`${BASE.api}/cstm-auth/${data.usrDmnId}`),
    getRoleList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/role?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),
    saveCstmUsrRoleList: (data: any) => api.post(`${BASE.api}`, data),
    // Get a excel list of Customs staff. !== 세관 직원 엑셀 목록을 조회한다. ==!
    getCstmUsrExcelList: (data: any) => api.get(`${BASE.api}/cstm-usr/excel`, { params: comnUtils.toGetParams(data) }),
};

export const SF_CSTM_USR_SRCH: TFormSchema = {
    id: "form_cstmUsrSrch",
    schema: {
        usrDmnId: { type: "text", label: "L_USR_DMN_ID" },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO" },
        cstmCd: { type: "code", label: "L_CSTM_OFCE", area: "cstmCd", popupSize: "md" },
        cstmOfcrNm: { type: "text", label: "L_NM" },
        roleId: { type: "code", label: "L_ROLE_ID", area: "roleCd" },
        usrStatCd: { type: "select", label: "L_STTS", all: true, area: "comnCd", comnCd: "PTL0001" },
    },
};

export const SF_ROLE_SRCH: TFormSchema = {
    id: "form_roleSrch",
    schema: {
        usrDmnId: { type: "text" },
        roleId: { type: "text", label: "L_ROLE_ID" },
        roleNm: { type: "text", label: "L_ROLE_NM" },
    },
};

export const SG_CSTM_USR_LIST: TGridSchema = {
    id: "grid_cstmUsrList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "0.8*" }] },
        { cells: [{ header: "L_USR_DMN_ID", binding: "usrDmnId", width: "0.8*" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "0.8*" }] },
        { cells: [{ header: "L_SCTN", binding: "sctnNm", width: "1.5*" }] },
        { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "1.5*" }] },
        { cells: [{ header: "L_UT_CD", binding: "unitNm", width: "1.5*" }] },
        { cells: [{ header: "L_USR_STAT", binding: "usrStatCdNm", width: "10%" }] },    ],
    body: [
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "usrDmnId", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "sctnNm", align: "left" }] },
        { cells: [{ binding: "cstmNm", align: "left" }] },
        { cells: [{ binding: "unitNm", align: "left" }] },
        { cells: [{ binding: "usrStatCdNm" }] },
    ],
};

export const SF_CSTM_OFCR_INFO: TFormSchema = {
    id: "form_cstmOfcrInfo",
    schema: {
        sctnNm: { type: "text", label: "L_SCTN", labelSize: 2, controlSize: 2, edit: false },
        cstmNm: { type: "text", label: "L_CSTM_OFCE", labelSize: 2, controlSize: 2, edit: false },
        unitNm: { type: "text", label: "L_UT", labelSize: 2, controlSize: 2, edit: false },
        usrDmnId: { type: "text", label: "L_USR_DMN_ID", labelSize: 2, controlSize: 2, edit: false },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO", labelSize: 2, controlSize: 2, edit: false },
        usrNm: { type: "text", label: "L_CSTM_OFCR_NM", labelSize: 2, controlSize: 2, edit: false },
        usrTelno: { type: "text", label: "L_TELNO", edit: false },
        usrEmlAddr: { type: "text", label: "L_EML_ADDR", edit: false },
    },
};

export const SF_ROLE_FILE_FORM: TFormSchema = {
    id: "form_roleFileForm",
    schema: {
    fileGrpUuid: {
            type: "file",
            multiple: false,
            controlSize: 10,
            disableName: true,
            disableDescription: true,
            disableTitle: true,
            isPublic: true,
            required: true,
        },
    },
};

export const SG_CSTM_USR_ROLE_LIST: TGridSchema = {
    id: "grid_cstmUsrRoleList",
    options: { checkbox: true, pagination: "in" },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_DESC", binding: "roleDesc", width: "*" }] },
        { cells: [{ header: "Attached File", binding: "attchFle", width: "*" }] },

    ],
    body: [
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "roleNm", align: "center" }] },
        { cells: [{ binding: "roleDesc", align: "center" }] },
        { cells: [{ binding: "attchFle", align: "center" }] },
    ],
};

export const SG_SCRH_ROLE_LIST: TGridSchema = {
    id: "grid_srchRoleList",
    options: { checkbox: true, pagination: "in" },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_DESC", binding: "roleDesc", width: "*" }] },
        { cells: [{ binding: "isRgsrYn", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "roleNm", align: "left" }] },
        { cells: [{ binding: "roleDesc", align: "center" }] },
        { cells: [{ binding: "isRgsrYn", align: "center" }] },
    ],
};

export const SG_CSTM_USR_EXCEL_LIST: TGridSchema = {
    id: "grid_cstmUsrExcelList",
    options: { index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "0.8*" }] },
        { cells: [{ header: "L_USR_DMN_ID", binding: "usrDmnId", width: "0.8*" }] },
        { cells: [{ header: "L_CSTM_OFCR_NO", binding: "cstmOfcrNo", width: "0.8*" }] },
        { cells: [{ header: "L_SCTN", binding: "sctnNm", width: "1.5*" }] },
        { cells: [{ header: "L_CSTM", binding: "cstmNm", width: "1.5*" }] },
        { cells: [{ header: "L_UT_CD", binding: "unitNm", width: "1.5*" }] },
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_DESC", binding: "roleDesc", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "usrNm", align: "left" }] },
        { cells: [{ binding: "usrDmnId", align: "left" }] },
        { cells: [{ binding: "cstmOfcrNo" }] },
        { cells: [{ binding: "sctnNm", align: "left" }] },
        { cells: [{ binding: "cstmNm", align: "left" }] },
        { cells: [{ binding: "unitNm", align: "left" }] },
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "roleNm", align: "center" }] },
        { cells: [{ binding: "roleDesc", align: "center" }] },
    ],
};
